import { render, staticRenderFns } from "./trans-handle.html?vue&type=template&id=1a8e70b4&scoped=true&external"
import script from "./trans-handle.js?vue&type=script&lang=js&external"
export * from "./trans-handle.js?vue&type=script&lang=js&external"
import style0 from "./trans-handle.scss?vue&type=style&index=0&id=1a8e70b4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e70b4",
  null
  
)

export default component.exports